import get from 'lodash/get';
import { IRun } from '@app/core/model/runs/run';
import _ from 'lodash';
import IResource from './resource';

export class FileStatus {

    public static readonly ACTIVE = 'Active';
    public static readonly ARCHIVED = 'Archived';
    public static readonly ARCHIVING = 'Archiving';
    public static readonly UNARCHIVING = 'Unarchiving';
    public static readonly ZIPPED = 'Zipped';
    public static readonly ZIPPING = 'Zipping';
    public static readonly ZIPPING_TEXT = 'Zipping...';
    public static readonly ZIPPED_ARCHIVED = 'Zipped & Archived';
    public static readonly UNZIPPING = 'Unzipping'; // may need this in feature
    public static readonly UNZIPPING_TEXT = 'Unzipping...'; // may need this in feature

    public static getFileStatus (resource:IResource): string
    {
      if (!resource) return this.ACTIVE;

      const statuses = resource.DataStatuses || [];
      const isArchived = _.includes(statuses, this.ARCHIVED);
      const isArchiving = _.includes(statuses, this.ARCHIVING);
      const isUnArchiving = _.includes(statuses, this.UNARCHIVING);
      const isZipping = _.includes(statuses, this.ZIPPING);
      const isZipped = _.includes(statuses, this.ZIPPED);
      const isUnZipping = _.includes(statuses, this.UNZIPPING);

      // Zipping applicable to runs only
      if (isArchived && isZipped) { return this.ZIPPED_ARCHIVED; }

      if (isArchiving) { return this.ARCHIVING; }

      if (isUnArchiving ) { return this.UNARCHIVING; }

      if (isArchived ) { return this.ARCHIVED; }

      if (isZipped) { return this.ZIPPED; }

      if (isZipping) { return this.ZIPPING_TEXT; }

      if (isUnZipping) { return this.UNZIPPING_TEXT; }

      return this.ACTIVE;
    }
   
    public static getFileStatusHelpText(resource: IResource): string {
      // Get the current status of the resource using helper function
      const status = FileStatus.getFileStatus(resource);

      // Shared help text for all zipped-related statuses
      const zipHelpText = `Runs that are 90 days or older are automatically zipped to reduce the total number of files.
      You can unzip these runs from the File menu on the Runs page.\nUnzipping may take a while depending on the size of the run.`;
    
      // Help text lookup table to avoid multiple if/else statements
      const helpTextMap: { [key: string]: string } = {
        // Special message for ZIPPED + ARCHIVED
        [FileStatus.ZIPPED_ARCHIVED]: `This run has been zipped and then archived. In order to access the data files in this run you will need to first unarchive the run, and then unzip it. Both operations may take a while depending on the size of the run.`,
        // Shared message for any zipped-related statuses
        [FileStatus.ZIPPED]: zipHelpText,
        [FileStatus.ZIPPING_TEXT]: zipHelpText,
        [FileStatus.UNZIPPING_TEXT]: zipHelpText,
      };
    
      return helpTextMap[status] || status;
    }
    
}
